'use strict';

const _ = require('underscore');
const GroupRepository = require('common/domain/repository/group');
const Task = require('communication/domain/entity/task');

class Factory {
    constructor(project) {
        this._project = project;
    }

    /**
     * json からタスクをビルドします。
     *
     * @param json = {
     *          id: {String} Task id
     *          name: {String} Task name
     *          state: {String} State name
     *          stateChoices: {Array} State names
     *          owner: {String} Owner id
     *          assignees: {Array} Assignee ids
     *          comments: {Array} Comment ids
     *          relatedKeys: {Array} Related keys
     *          updatedAt: {String} Updated time
     *          updatedBy: {String} Updated user id
     *      }
     * @returns {Promise<any>}
     */
    build(json) {
        const task = new Task(json);

        const group = GroupRepository.getGroups().get(this._project.getGroupId());
        const members = group.getMembers({withSuspended: true});
        if(json.owner) {
            const owner = members.getMemberByUser(json.owner);
            task.setOwner(owner);
        }
        if(json.assignees) {
            const assignees = _.map(json.assignees, a => {
                return members.getMemberByUser(a);
            });
            task.setAssignees(assignees);
        }
        if(json.updatedBy) {
            const updatedBy = members.getMemberByUser(json.updatedBy);
            task.setUpdatedBy(updatedBy);
        }

        return new Promise((resolve, reject) => {
            resolve(task);
        });
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./communication/domain/factory/task.js